// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./~/extract-text-webpack-plugin/loader.js?{"omit":1,"remove":true}!./~/vue-style-loader!./~/css-loader?{"minimize":true,"sourceMap":true}!./~/vue-loader/lib/style-compiler?{"id":"data-v-65b68730","scoped":false,"hasInlineConfig":false}!./~/vue-multiselect/dist/vue-multiselect.min.css
// module id = 866
// module chunks = 1